import { instructionalPart3Description } from '../content/instructionalPart3';

import { unemployabilityTitle } from '../content/unemployabilityFormIntro';

export const uiSchema = {
  'ui:title': unemployabilityTitle,
  'ui:description': instructionalPart3Description,
};

export const schema = {
  type: 'object',
  properties: {},
};
